export default {
      id: "checked-usage",
      viewBox: "0 0 10 8",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#checked-usage",
      toString: function () {
        return this.url;
      }
    }